'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDashboardBuilderTile, iconDashboardBuilderTileTag } from '@ni/nimble-components/dist/esm/icons/dashboard-builder-tile';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDashboardBuilderTile };
export { iconDashboardBuilderTileTag };
export const NimbleIconDashboardBuilderTile = wrap(IconDashboardBuilderTile);